// @ts-nocheck
import { useState, useCallback } from "react"
import { supabaseClient } from "@/lib/supabase/client"

export function useSearch() {
  const [results, setResults] = useState<{ posts: any[]; users: any[]; topics: any[] }>({ posts: [], users: [], topics: [] })
  const [loading, setLoading] = useState(false)

  const search = useCallback(async (q: string) => {
    if (!q.trim()) { setResults({ posts: [], users: [], topics: [] }); return }
    setLoading(true)
    try {
      const term = `%${q.trim()}%`
      const [{ data: posts }, { data: users }, { data: topics }] = await Promise.all([
        supabaseClient.from("posts").select("id, title, slug, vote_score, created_at, users!posts_author_id_fkey(username, display_name)").ilike("title", term).eq("status", "published").limit(10),
        supabaseClient.from("users").select("id, username, display_name, avatar_url, is_verified, karma_score").ilike("username", term).limit(8),
        supabaseClient.from("topics").select("id, name, slug, post_count").ilike("name", term).limit(6),
      ])
      setResults({ posts: posts || [], users: users || [], topics: topics || [] })
    } finally { setLoading(false) }
  }, [])

  return { results, loading, search }
}
